<template>
  <div id="app">
    <app-header :iddiario="iddiario"/>
    <app-section-intro />
    <app-section-card-description />
    <app-section-medal-table-calendar />
    <app-footer />
  </div>
</template>

<script>
import AppHeader from './components/commons/AppHeader.vue'
import AppSectionIntro from './components/sections/AppSectionIntro.vue'
import AppSectionCardDescription from './components/sections/AppSectionCardDescription.vue'
import AppSectionMedalTableCalendar from './components/sections/AppSectionMedalTableCalendar.vue'
import AppFooter from './components/commons/AppFooter.vue'
import { auth } from '@/services'
export default {
  data () {
    return {
      iddiario: window.app.idDiario
    }
  },
  components: { AppHeader, AppSectionIntro, AppSectionCardDescription, AppSectionMedalTableCalendar, AppFooter },
  mounted() {
    auth.init(this)
  }
}
</script>

<style lang="scss">
  @import './src/styles/vendor.scss';
  @import './src/styles/main.scss';
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;1,100&display=swap');

body {
  overflow-x: hidden;
}
</style>
